// News listing + details events (analytics sheet → "News listing" and "News
// details page" sections).
import {logAnalyticsEvent} from './analytics';
import {AnalyticsEntryPoint} from './events';
import type {TrackedItem} from './shared';

const LISTING = AnalyticsEntryPoint.NewsListing;
const DETAILS = AnalyticsEntryPoint.NewsDetailsPage;

export function trackNewsCategoryFilter(categoryName: string, previousCategoryName?: string) {
  logAnalyticsEvent('filter_click', {
    entry_point: LISTING,
    category_name: categoryName,
    previous_category_name: previousCategoryName,
  });
}

export function trackNewsListingCardClick(item: TrackedItem) {
  logAnalyticsEvent('card_click', {
    entry_point: LISTING,
    item_id: item.id,
    item_name: item.name,
  });
}

export function trackNewsGalleryClick(item?: TrackedItem) {
  logAnalyticsEvent('gallery_click', {
    entry_point: DETAILS,
    item_id: item?.id,
    item_name: item?.name,
  });
}

export function trackNewsLinkClick(redirectionLink: string, item?: TrackedItem) {
  logAnalyticsEvent('link_click', {
    entry_point: DETAILS,
    redirection_link: redirectionLink,
    item_id: item?.id,
    item_name: item?.name,
  });
}
